module.exports = __webpack_public_path__ + "static/media/triple-ball.af9d3a6c.svg";